import { Modal, Button, Form, Badge, Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import EstadoMotivo from "./EstadoMotivo";
import MotivoAdministrador from "./MotivoAdministrador";
import { getMotivosEstudiante } from "../../services/apis_estudiante";
import { crearMotivo, actualizarMotivo } from "../../services/apis_jefatura";

function AdministrarMotivosModal({ show, onClose, onMotivosChanged }) {
  const [motivos, setMotivos] = useState([]);
  const [nuevoMotivo, setNuevoMotivo] = useState("");
  const [motivoEditando, setMotivoEditando] = useState(null);
  const [nombreEditado, setNombreEditado] = useState("");
  const [loading, setLoading] = useState(false);

  const motivosOrdenados = [...motivos].sort((a, b) => {
    //activo == true primero
    if (a.activo !== b.activo) {
      return a.activo ? -1 : 1;
    }
    //ordenar alfabeticamente
    return a.nombre.localeCompare(b.nombre, "es", { sensitivity: "base" });
  });

  useEffect(() => {
    if (show) {
      fetchMotivos();
    }
  }, [show]);

  const fetchMotivos = async () => {
    try {
      const data = await getMotivosEstudiante();
      setMotivos(data);
    } catch (err) {
      console.error("Error cargando motivos:", err);
    }
  };

  const handleCrearMotivo = async () => {
    if (!nuevoMotivo.trim()) {
      alert("El nombre del motivo no puede estar vacío");
      return;
    }

    setLoading(true);
    try {
      await crearMotivo(nuevoMotivo.trim());
      setNuevoMotivo("");
      await fetchMotivos();
      onMotivosChanged?.();
    } catch (err) {
      console.error("Error creando motivo:", err);
      alert("Error al crear el motivo");
    } finally {
      setLoading(false);
    }
  };

  const handleToggleActivo = async (motivo) => {
    try {
      await actualizarMotivo(motivo.id, { activo: !motivo.activo });
      await fetchMotivos();
      onMotivosChanged?.();
    } catch (err) {
      console.error("Error actualizando motivo:", err);
      alert("Error al actualizar el motivo");
    }
  };

  const handleStartEdit = (motivo) => {
    setMotivoEditando(motivo.id);
    setNombreEditado(motivo.nombre);
  };

  const handleCancelEdit = () => {
    setMotivoEditando(null);
    setNombreEditado("");
  };

  const handleSaveEdit = async (motivoId) => {
    if (!nombreEditado.trim()) {
      alert("El nombre del motivo no puede estar vacío");
      return;
    }

    try {
      await actualizarMotivo(motivoId, { nombre: nombreEditado.trim() });
      setMotivoEditando(null);
      setNombreEditado("");
      await fetchMotivos();
      onMotivosChanged?.();
    } catch (err) {
      console.error("Error actualizando motivo:", err);
      alert("Error al actualizar el motivo");
    }
  };

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Administrar Motivos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Sección: Crear nuevo motivo */}
        <div className="mb-4 p-3 border rounded bg-light">
          <h5 className="mb-3">Crear Nuevo Motivo</h5>
          <Form.Group as={Row} className="align-items-center">
            <Col xs={8}>
              <Form.Control
                type="text"
                placeholder="Nombre del motivo"
                value={nuevoMotivo}
                onChange={(e) => setNuevoMotivo(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleCrearMotivo();
                  }
                }}
              />
            </Col>
            <Col xs={4}>
              <Button
                className="btn-accent w-100"
                onClick={handleCrearMotivo}
                disabled={loading || !nuevoMotivo.trim()}
              >
                {loading ? "Creando..." : "Crear"}
              </Button>
            </Col>
          </Form.Group>
        </div>

        {/* Sección: Lista de motivos existentes */}
        <div>
          <div className="d-flex align-items-center mb-3">
            <p className="fs-5 fw-semibold mb-0">Motivos Existentes</p>
            <p className="mb-0 ms-2 text-muted">
              ({motivos.filter((m) => m.activo).length} activos /{" "}
              {motivos.filter((m) => !m.activo).length} inactivos)
            </p>
          </div>
          {motivos.length === 0 ? (
            <p className="text-muted">No hay motivos disponibles.</p>
          ) : (
            <Row className="g-2">
              {motivosOrdenados.map((motivo) => (
                <Col key={motivo.id} xs={12} className="d-flex">
                  <MotivoAdministrador
                    motivo={motivo}
                    motivoEditando={motivoEditando}
                    nombreEditado={nombreEditado}
                    onStartEdit={handleStartEdit}
                    onCancelEdit={handleCancelEdit}
                    onSaveEdit={handleSaveEdit}
                    onNombreEditadoChange={setNombreEditado}
                    onToggleActivo={handleToggleActivo}
                  />
                </Col>
              ))}
            </Row>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AdministrarMotivosModal;
